<script setup>
import Heading from '@/components/shared/page/Heading.vue'
import Markdown from '@/components/shared/transform/Markdown.vue'
import StatusDot from '@/components/shared/core/StatusDot.vue'
import DateTimeRelative from '@/components/shared/transform/DateTimeRelative.vue'

//Emits and props
defineEmits([
  'click',
])
defineProps({
  header: {
    type: String,
    default: '',
  },
  subheader: {
    type: String,
    default: '',
  },
  preview: {
    type: String,
    default: '',
  },
  timestamp: {
    type: [Object, String],
    default: '',
  },
  showDot: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div
    :class="$style.card"
    v-bind="$attrs"
    hide-empty
    @click="$emit('click', $event)"
  >
    <div :class="$style.image">
      <div :class="$style.dot">
        <StatusDot
          v-if="showDot"
          status="info"
          size="s"
        />
      </div>
      <slot name="image" />
    </div>
    <div :class="$style.content">
      <div :class="$style.header">
        <Heading
          size="s"
          :has-margin="false"
          :class="$style.heading"
        >
          <slot name="header">
            {{ header }}
          </slot>
        </Heading>
        <small
          v-if="timestamp"
          text-muted
        >
          <DateTimeRelative :date="timestamp" />
        </small>
      </div>
      <div :class="$style.subheader">
        <div :class="$style.heading">
          {{ subheader }}
        </div>
        <slot name="badge" />
      </div>

      <div :class="$style.preview">
        <Markdown
          :class="$style.markdown"
          :content="preview"
          strip-tags
        />
      </div>
      <slot />
    </div>
  </div>
</template>

<style module>
.card {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 1rem;
  &:first-child {
    .content {
      border-top: 1px solid var(--color-borders);
    }
  }
}
.image {
  padding-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dot {
  margin-left: -0.875rem;
  width: 0.875rem;
}
.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  border-bottom: 1px solid var(--color-borders);
  padding: 1rem 0;
}
.header, .subheader {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}
.heading {
  flex: 1;
  display: block;
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.preview {
  flex: 1;
  color: var(--color-text-muted);
  line-height: var(--line-height-text);
  overflow: hidden;
}
.markdown {
  max-height: 2.5rem;
  display: block;
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
